import { Localized } from "@fluent/react"
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Alert, Typography, TextField } from "@mui/material"
import { useAppDispatch } from "../../../app/hooks";
import { useState } from "react";
import { CancelButton } from "../../../app/components/CancelButton";
import { showSuccess } from "../../notifications/notificationsSlice";
import { deleteAppUserFunc } from "../administration";
import { DeleteButton } from "../../../app/components/DeleteButton";

export interface DeleteUserDialogProps {
    email: string;
    onSuccessfullySaved: (updated: any) => void;
    onCancel: () => void
}

export const DeleteUserDialog = ({ email, onSuccessfullySaved, onCancel }: DeleteUserDialogProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState<boolean>(false);
    const [password, setPassword] = useState<string>("");
    const [serverError, setServerError] = useState(""); 

    const handleSubmitClick = async() => {
        try {
            setLoading(true)
            const result = await dispatch(deleteAppUserFunc({ email, password }));
            if (deleteAppUserFunc.fulfilled.match(result)) {
                dispatch(showSuccess("saved"))
                onSuccessfullySaved({ });
            } else {
                let errorMsg = "error"
                if (result.payload) {
                    if (result.payload.kind === 'http') {
                        const problem = result.payload.problem
                        if (problem) {
                            errorMsg = problem.title
                        }
                    }
                }
                setServerError(errorMsg)
            }
        } catch (error) {
            setServerError("error");
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="user-delete-dialog-title">
                    <span>_Usuń użytkownika</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Alert
                        severity="warning"
                        variant="outlined"
                        sx={{
                            mb: 2,
                            mt: 2,
                            alignItems: "flex-start",
                            "& .MuiAlert-message": {
                                width: "100%",
                            },
                        }}
                    >
                        <Typography variant="body2">
                            <Localized id="user-delete-dialog-alert">
                                <span>_Treść alertu</span>
                            </Localized>
                        </Typography>
                    </Alert>

                    <TextField
                        sx={{ mt: 2 }}
                        fullWidth
                        value={password}
                        required
                        onChange={(e) => setPassword(e.target.value)}
                        type={"password"}
                        label={<Localized id="password">_Hasło</Localized>}
                        helperText={<Localized id="autorization-password-required"><span>Wymagana autoryzacja hasłem</span></Localized>}
                    />
                </DialogContentText>

                {serverError && (
                    <Alert sx={{ marginTop: 1 }} severity="error">
                        <Localized id={serverError}>
                            <span style={{ whiteSpace: 'pre-line' }}>{serverError}</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <DeleteButton
                    loading={loading}
                    onClick={handleSubmitClick}
                />
                <CancelButton
                    loading={loading}
                    onClick={onCancel}
                />
            </DialogActions>
        </>
    )
}